// extracted by mini-css-extract-plugin
export default {"headerStatus":"Products_headerStatus__GxL6L"};